export default __webpack_public_path__ + "static/media/640_dummy2016-schauspieler01-de.f67d830d.png";